import Vue from "vue";
import Vuetify from "vuetify";

// Translation provided by Vuetify (javascript)
import { ko } from "vuetify/src/locale";

// VCurrencyField
import VCurrencyField from "v-currency-field";
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    breakpoint: {
        mobileBreakpoint: "md",
        thresholds: {
            xs: 576,
            sm: 768,
            md: 1024,
            lg: 1200,
        },
        scrollBarWidth: 0,
    },
    themes: {
        light: {
            primary: {
                base: "#78BC31",
                lighten5: "#EFF7E6",
                lighten4: "#D7EBC1",
                lighten3: "#BCDE98",
                lighten2: "#A1D06F",
                lighten1: "#8CC650",
                darken1: "#70B62C",
                darken2: "#65AD25",
                darken3: "#5BA51F",
                darken4: "#489713",
                accent1: "#DDFFC9",
                accent2: "#BDFF96",
                accent3: "#9CFF63",
                accent4: "#8CFF4A",
            },
            secondary: {
                base: "#EA642D",
                lighten5: "#FCECE6",
                lighten4: "#F9D1C0",
                lighten3: "#F5B296",
                lighten2: "#F0936C",
                lighten1: "#ED7B4D",
                darken1: "#E75C28",
                darken2: "#E45222",
                darken3: "#E1481C",
                darken4: "#DB3611",
                accent1: "#FFF",
                accent2: "#FFDCD5",
                accent3: "#FFB1A2",
                accent4: "#FF9B89",
            },
            accent: "#82B1FF",
            error: "#FF5252",
            info: "#2196F3",
            success: "#4CAF50",
            warning: "#FFC107",
            anchor: "inherit",
            grey: {
                base: "#666",
                lighten5: "#f7f7f7",
                lighten4: "#ececec",
                lighten3: "#ddd",
                lighten2: "#aaa",
                lighten1: "#999",
                darken1: "#555",
                darken2: "#444",
                darken3: "#333",
                darken4: "#111",
            },
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: "#00C73C",
            secondary: "#445163",
            accent: "#00C73C",
            // error: '#FF5252',
            info: "#2D3539",
            content: "#EDF0F5",
            // success: '#4CAF50',
            // warning: '#FFC107',
            anchor: "#333",
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    },
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function(theme) {
    return new Vuetify({
        lang: {
            locales: { ko },
            current: "ko",
        },
        theme: theme || basicTheme,
    });
}
